import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getCardsConfig() {
    const PALETTE = {
        [PALETTE_IDS.EVENT_CARDS]: {
            CARD_EVENT_NAME_TEXT: COLOR.BRAND.FOREGROUND5,

            CARD_BASE_HEADER_TEXT: {
                fontFamily: FONT.FAMILY_FUTURA,
                fontSize: FONT.SIZE_XSMALL,
                fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                color: COLOR.BRAND.FOREGROUND5,
            },

            CARD_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND4,
            CARD_SHOW_ALL_LINK: {
                SECONDARY_LINK_TEXT: COLOR.BRAND.FOREGROUND4,
            },
            CARD_BET_NOW_LINK: {
                SECONDARY_LINK_TEXT: {
                    color: COLOR.BRAND.FOREGROUND4,
                    textTransform: 'uppercase',
                },
            },

            CARD_SPORT_ICON_COLOR: COLOR.BRAND.FOREGROUND4,

            CARD_WATERMARK_ICON_OPACITY: 0.4,
            CARD_WATERMARK_ICON_COLOR: COLOR.BRAND.BACKGROUND7,
            CARD_RUNNER_INFO: {
                RUNNER_TRAINER_AND_JOCKEY_NAMES_TEXT: COLOR.BRAND.FOREGROUND4,
                RUNNER_NAME_TEXT: COLOR.BRAND.FOREGROUND4,
            },
            CARD_TIMING_STATUS: {
                EVENT_TIMING_LIVE_TEXT: COLOR.BRAND.FOREGROUND5,
                EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND5,
            },
            CARD_MINI_SCOREBOARD: {
                MINI_SCOREBOARD_SCORES_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND4,
                },
                MINI_SCOREBOARD_SCORE_COUNT_TEXT: {
                    color: COLOR.BRAND.FOREGROUND4,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                MINI_SCOREBOARD_SEGMENT_INDICATOR_TEXT: COLOR.BRAND.FOREGROUND4,
                MINI_SCOREBOARD_SERVER_INDICATOR: COLOR.BRAND.FOREGROUND4,
            },
            CARD_RACE_INFO_TEXT: COLOR.BRAND.FOREGROUND4,

            CARD_SELECTION_MARKET_TEXT: {
                color: COLOR.BRAND.FOREGROUND4,
                fontWeight: FONT.WEIGHT_BOLD,
            },
            CARD_SELECTION_PRICE_BOOST_CONTAINER_BG: COLOR.BRAND.BACKGROUND3,
            CARD_SELECTION_PRICE_BOOST_LABEL: {
                PRICE_BOOST_LABEL_ICON_CONTAINER_BG: COLOR.BRAND.FOREGROUND4,
                PRICE_BOOST_LABEL_ICON_COLOR: COLOR.BRAND.ACCENT1,
                PRICE_BOOST_LABEL_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND4}|${COLOR.BRAND.FOREGROUND1}`,
                    fontSize: 10,
                },
            },
            CARD_MATCH_ACCA_EVENT_NAME_TEXT: {
                color: COLOR.BRAND.FOREGROUND4,
                fontWeight: FONT.WEIGHT_SEMI_BOLD,
            },
            CARD_MATCH_ACCA_EVENT_INFO_TEXT: COLOR.BRAND.FOREGROUND4,
            CARD_MATCH_ACCA_SELECTION_ITEM: {
                BB_BET_MARKET_TEXT: COLOR.BRAND.FOREGROUND4,
                BB_BET_SELECTION_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND4,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    textTransform: 'none',
                },
                BB_BET_PATH_LINE_COLOR: COLOR.BRAND.FOREGROUND5,
            },
            CARD_PREBUILT_ACCA_SELECTION_BB_BET_MARKET_TEXT: COLOR.BRAND.FOREGROUND4,
            CARD_PREBUILT_ACCA_SELECTION_BB_BET_EVENT_TEXT: COLOR.BRAND.FOREGROUND4,
            CARD_MATCH_ACCA_BB_BET_ICON_COLOR: COLOR.BRAND.FOREGROUND4,
            CARD_GAMELINE_MARKET_HEADER_TEXT: {
                fontWeight: FONT.WEIGHT_NORMAL,
                color: COLOR.BRAND.FOREGROUND4,
            },
        },
    };

    return {
        custom: {
            [PALETTE_IDS.EVENT_CARDS]: {},
        },
        palette: PALETTE,
    };
}
